export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-at-sign-66264d1daea27705910da206544520d9.svg";